import "./styles.scss";

import { useTranslation } from "react-i18next";
import moment from "moment";

import Calendar from "components/Calendar";

const mainClass = "task-view-main-completion";

const Completion = ({ due_date, isClient, isCompletelyDisabled, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className={mainClass}>
      <p>
        {due_date
          ? moment(due_date).format("LL")
          : !isCompletelyDisabled && !isClient
            ? t("Select date")
            : "-"}
      </p>
      {typeof onChange === "function" && (
        <Calendar only_icon default_value={due_date} onChange={onChange} />
      )}
    </div>
  );
};

export default Completion;
